<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          large
          text
          outlined
          rounded
          class="ma-3"
          >ADD DEFENDANT</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
        "
      >
        <v-card-title>
          <span class="headline">ADD DEFENDANT</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddDefendant" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <v-text-field
                label="DEFENDANT FULL NAME"
                name="name"
                validate-on-blur
                required
                id="name"
                class="ma-2"
                outlined
                v-model="fullName"
                autofocus
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <v-radio-group v-model="type" row>
                <v-radio label="Individual" value="individual"></v-radio>
                <v-radio label="Business" value="business"></v-radio>
                <v-radio label="Government" value="government"></v-radio>
              </v-radio-group>
              <v-text-field
                label="STREET ADDRESS"
                name="addressline1"
                id="adressline1"
                class="ma-2"
                outlined
                v-model="addressLine1"
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <v-text-field
                label="CITY, STATE &amp; ZIP"
                name="cityStateZip"
                id="cityStateZip"
                class="ma-2"
                outlined
                v-model="cityStateZip"
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <div v-if="type !== 'business' && type !== 'government'">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  color="#a07800"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateOfBirth"
                      readonly
                      v-on="on"
                      label="DATE OF BIRTH"
                      name="dateOfBirth"
                      validate-on-blur
                      required
                      id="dateOfBirth"
                      class="ma-2"
                      outlined
                      clearable
                      color="#2E5473"
                      dense
                      filled
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    :max="new Date().toISOString().substr(0, 10)"
                    clearable
                    v-model="dateOfBirth"
                    @input="menu = false"
                    color="#2E5473"
                    dense
                    filled
                  ></v-date-picker>
                </v-menu>
              </div>

              <v-text-field
                label="DEFENDANT PHONE"
                name="phone"
                validate-on-blur
                required
                id="phone"
                class="ma-2"
                outlined
                v-model="phone"
                v-mask="mask"
                clearable
                type="tel"
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <v-text-field
                label="EMAIL"
                name="email"
                validate-on-blur
                required
                id="email"
                class="ma-2"
                outlined
                v-model="email"
                clearable
                :rules="[rules.email]"
                type="email"
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <!-- ATTORNEY NAME  -->
              <v-text-field
                label="ATTORNEY NAME "
                name="attorney"
                required
                id="attorney"
                class="ma-2"
                outlined
                v-model="attorney"
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >SUBMIT</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
//
//
//
//
//
// THIS WHOLE COMPONENT NEEDS TO BE CHANGES TO MATCH THE PLAINTIFF COMPONENT
//
//
//
//
import { mask } from "vue-the-mask";
import * as moment from "moment";
export default {
  props: ["matter", "user"],
  directives: {
    mask
  },
  data() {
    return {
      menu: false,
      dialog: false,
      // allowSave: false,
      mask: "(###) ###-####",
      fullName: null,
      addressLine1: null,
      cityStateZip: null,
      phone: null,
      email: null,
      attorney: null,
      dateOfBirth: null,
      type: null,
      insurance: [],
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  computed: {
    formIsValid() {
      return this.fullName !== null && this.dataOfBirth !== null;
    }
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    cancelDialog() {
      this.menu = false;
      this.dialog = false;
      this.allowSave = false;
      this.fullName = null;
      this.addressLine1 = null;
      this.cityStateZip = null;
      this.phone = null;
      this.email = null;
      this.attorney = null;
      this.dateOfBirth = null;
      this.type = null;
      this.insurance = [];
    },
    onAddDefendant() {
      let activity = {
        content: `${this.user.email} added a new defendant to ${this.matter.caseName}, named ${this.fullName}.`,
        matterID: this.$route.params.id,
        date: moment().format("MMMM Do YYYY, h:mm:ss a"),
        user: this.user
      };
      const payload = {
        defendant: {
          fullName: this.fullName,
          addressLine1: this.addressLine1,
          cityStateZip: this.cityStateZip,
          phone: this.phone,
          email: this.email,
          attorney: this.attorney,
          dateOfBirth: this.dateOfBirth,
          type: this.type,
          insurance: this.insurance
        },
        firmSlug: this.user.firmSlug,
        matterSlug: this.matter.matterSlug,
        activity
      };

      console.log(payload);

      //THIS SENDS THE DEFENDANT OBJECT TO VUEX AND VUEX SAVES IT TO THE DATABASE
      this.$store.dispatch("addDefendant", payload);

      this.menu = false;
      this.dialog = false;
      this.allowSave = false;
      this.fullName = null;
      this.addressLine1 = null;
      this.cityStateZip = null;
      this.phone = null;
      this.email = null;
      this.attorney = null;
      this.dateOfBirth = null;
      this.type = null;
      this.insurance = null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
